import { configureStore, Store } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { incApi } from 'api/inc-api';
import logger from 'redux-logger';
import { persistStore } from 'redux-persist';
import { rtkQueryErrorHandler } from './middleware/api-error-handler.middleware';
import { rtkQueryLogoutMiddleware } from './middleware/api-logout.middleware';
import { notificationMiddleware } from './middleware/notification-middleware';
import rootReducer from './root-reducer';

/* istanbul ignore next */
const middleware = getDefaultMiddleware => {
  const ignoreSerializableCheck =
    process.env.REACT_APP_ENV === 'test' ||
    window.Cypress ||
    process.env.STORYBOOK;

  const mw = getDefaultMiddleware({
    serializableCheck: ignoreSerializableCheck
      ? false
      : {
          ignoredActions: ['persist/PERSIST'],
        },
    immutableCheck: !ignoreSerializableCheck,
  }).concat(
    incApi.middleware,
    rtkQueryErrorHandler,
    rtkQueryLogoutMiddleware,
    notificationMiddleware,
  );

  if (process.env.NODE_ENV === 'development') {
    mw.push(logger);
  }

  return mw;
};

let store: Store;
let persistor;

export const makeStore = (
  preloadedState = window.Cypress && window.initialState
    ? window.initialState
    : undefined,
) => {
  store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware,
  });

  persistor = persistStore(store);
  setupListeners(store.dispatch);

  /* istanbul ignore else */
  if (window.Cypress) {
    window.store = store;
    window.persistor = persistor;
  }

  return store;
};

export const getStore = () => store;
export const getPersistor = () => persistor;
